import { createContext, useContext, useState } from "react";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
    const [open, setOpen] = useState(false);

    const openSettings = () => setOpen(true);
    const closeSettings = () => setOpen(false);

    return (
        <SettingsContext.Provider value={{ open, openSettings, closeSettings }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    return useContext(SettingsContext);
}
